<gen-notes
        [nonAberation]="payload.nonAberation"
        [queryType]="payload.queryType ? payload.queryType : 'and'"
        [actorType]="payload.actorType"
        [actorId]="payload.actorId"
        [contextType]="payload.contextType"
        [contextId]="payload.contextId"
        [newNotes]="payload.newNotes"
        [filters]="payload.filters"
        [ngClass]="payload.classes"
        [readOnly]="payload.readOnly"
        (noteAddedEmit)="noteAddedEmit($event)"
></gen-notes>
